import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-24535c37"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  "element-loading-text": "数据涉及到大量的查询计算过程，请耐心等待......",
  "element-loading-background": "rgba(0, 0, 0, 0.5)",
  style: {"padding-top":"0px"}
}
const _hoisted_2 = { style: {"height":"50px","overflow-y":"hidden","line-height":"50px","font-size":"14px","font-weight":"900","margin-top":"-10px"} }
const _hoisted_3 = {
  key: 2,
  style: {"float":"left","width":"70px","color":"#00a9fc"}
}
const _hoisted_4 = {
  key: 3,
  style: {"float":"left","text-align":"center","color":"red","width":"calc(100% - 210px)"}
}
const _hoisted_5 = { style: {"float":"right"} }
const _hoisted_6 = { style: {"width":"100%","overflow":"hidden"} }
const _hoisted_7 = { style: {"clear":"both"} }
const _hoisted_8 = { style: {"padding-bottom":"0px"} }
const _hoisted_9 = { class: "el-alert__content" }
const _hoisted_10 = { class: "el-alert__title" }
const _hoisted_11 = { class: "el-alert__content" }
const _hoisted_12 = { class: "el-alert__title" }
const _hoisted_13 = { class: "el-alert__content" }
const _hoisted_14 = { class: "el-alert__title" }
const _hoisted_15 = { style: {"font-weight":"900","font-size":"14px"} }
const _hoisted_16 = {
  key: 0,
  style: {"float":"left"}
}
const _hoisted_17 = {
  key: 1,
  style: {"float":"left"}
}
const _hoisted_18 = {
  key: 2,
  style: {"float":"left"}
}
const _hoisted_19 = {
  key: 3,
  style: {"float":"left"}
}
const _hoisted_20 = {
  key: 4,
  style: {"float":"left"}
}
const _hoisted_21 = {
  key: 5,
  style: {"margin-left":"20px"}
}
const _hoisted_22 = {
  key: 6,
  style: {"float":"right"}
}
const _hoisted_23 = {
  key: 7,
  style: {"float":"left","margin-left":"30px","color":"red","padding-bottom":"10px"}
}
const _hoisted_24 = {
  key: 0,
  style: {"clear":"both"}
}
const _hoisted_25 = {
  key: 0,
  ref: "divGrossProfitChart",
  style: {"width":"100%","height":"300px"}
}
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { style: {"margin-top":"10px","width":"100%"} }
const _hoisted_28 = { style: {"clear":"both","font-size":"12px","line-height":"30px"} }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"900","float":"left","width":"70px"} }, " 币制 ", -1))
const _hoisted_30 = { style: {"float":"left","width":"150px"} }
const _hoisted_31 = { style: {"clear":"both","font-size":"12px","line-height":"30px"} }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"900","float":"left","width":"70px"} }, " 利润 ", -1))
const _hoisted_33 = { style: {"float":"left","width":"150px"} }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = {
  key: 0,
  style: {"font-weight":"900","float":"left","width":"70px"}
}
const _hoisted_36 = {
  key: 1,
  style: {"float":"left","width":"150px"}
}
const _hoisted_37 = {
  key: 2,
  style: {"font-weight":"900","float":"left","width":"70px"}
}
const _hoisted_38 = {
  key: 3,
  style: {"float":"left","width":"150px"}
}
const _hoisted_39 = { style: {"padding-top":"10px","font-weight":"900","line-height":"36px"} }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_41 = {
  key: 0,
  style: {"margin-top":"10px"}
}
const _hoisted_42 = {
  key: 2,
  style: {"width":"100%","text-align":"center","line-height":"40px"}
}
const _hoisted_43 = {
  key: 1,
  style: {"clear":"both","padding-top":"1px"}
}
const _hoisted_44 = { key: 0 }
const _hoisted_45 = { style: {"margin-top":"15px"} }
const _hoisted_46 = { style: {"margin-top":"10px","width":"100%"} }
const _hoisted_47 = { style: {"clear":"both","font-size":"12px","line-height":"30px"} }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"900","float":"left","width":"70px"} }, " 币制 ", -1))
const _hoisted_49 = { style: {"float":"left","width":"150px"} }
const _hoisted_50 = { style: {"clear":"both","font-size":"12px","line-height":"30px"} }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"900","float":"left","width":"70px"} }, " 总金额 ", -1))
const _hoisted_52 = { style: {"float":"left","width":"150px"} }
const _hoisted_53 = ["onClick"]
const _hoisted_54 = { style: {"clear":"both","font-size":"12px","line-height":"30px"} }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"900","float":"left","width":"70px"} }, " 已开票 ", -1))
const _hoisted_56 = { style: {"float":"left","width":"150px"} }
const _hoisted_57 = ["onClick"]
const _hoisted_58 = { style: {"clear":"both","font-size":"12px","line-height":"30px"} }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"900","float":"left","width":"70px"} }, " 未开票 ", -1))
const _hoisted_60 = { style: {"float":"left","width":"150px"} }
const _hoisted_61 = ["onClick"]
const _hoisted_62 = { style: {"clear":"both","font-size":"12px","line-height":"30px"} }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"900","float":"left","width":"70px"} }, " 已核销 ", -1))
const _hoisted_64 = { style: {"float":"left","width":"150px"} }
const _hoisted_65 = ["onClick"]
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"900","float":"left","width":"50px","margin-left":"60px"} }, " 逾期 ", -1))
const _hoisted_67 = { style: {"float":"left","width":"150px"} }
const _hoisted_68 = ["onClick"]
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"900","float":"left","width":"50px","margin-left":"60px"} }, " 坏账 ", -1))
const _hoisted_70 = { style: {"float":"left","width":"150px"} }
const _hoisted_71 = ["onClick"]
const _hoisted_72 = { style: {"clear":"both","font-size":"12px","line-height":"30px"} }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"900","float":"left","width":"70px"} }, " 未核销 ", -1))
const _hoisted_74 = { style: {"float":"left","width":"150px"} }
const _hoisted_75 = ["onClick"]
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"900","float":"left","width":"50px","margin-left":"60px"} }, " 逾期 ", -1))
const _hoisted_77 = { style: {"float":"left","width":"150px"} }
const _hoisted_78 = ["onClick"]
const _hoisted_79 = {
  key: 1,
  style: {"width":"100%","text-align":"center","line-height":"40px"}
}
const _hoisted_80 = {
  key: 2,
  style: {"margin-top":"10px","clear":"both"}
}
const _hoisted_81 = { style: {"clear":"both","padding-top":"5px"} }
const _hoisted_82 = {
  key: 0,
  style: {"text-align":"left"}
}
const _hoisted_83 = { key: 2 }
const _hoisted_84 = { key: 0 }
const _hoisted_85 = {
  key: 0,
  title: "订单已锁定"
}
const _hoisted_86 = {
  key: 1,
  title: "账单已锁定"
}
const _hoisted_87 = ["onClick"]
const _hoisted_88 = { key: 3 }
const _hoisted_89 = { key: 1 }
const _hoisted_90 = {
  key: 0,
  title: "账单已锁定",
  style: {"padding-right":"5px"}
}
const _hoisted_91 = {
  key: 1,
  title: "订单已锁定",
  style: {"padding-right":"5px"}
}
const _hoisted_92 = {
  key: 3,
  style: {"width":"100%","word-break":"break-all","text-align":"left"}
}
const _hoisted_93 = { key: 1 }
const _hoisted_94 = { key: 0 }
const _hoisted_95 = { key: 1 }
const _hoisted_96 = { style: {"width":"100%","word-break":"break-all","text-align":"left"} }
const _hoisted_97 = { key: 2 }
const _hoisted_98 = { key: 0 }
const _hoisted_99 = { key: 1 }
const _hoisted_100 = { style: {"width":"100%","word-break":"break-all","text-align":"left"} }
const _hoisted_101 = { key: 3 }
const _hoisted_102 = { key: 0 }
const _hoisted_103 = { key: 1 }
const _hoisted_104 = { style: {"width":"100%","word-break":"break-all","text-align":"left"} }
const _hoisted_105 = { key: 4 }
const _hoisted_106 = { key: 0 }
const _hoisted_107 = { key: 1 }
const _hoisted_108 = { style: {"width":"100%","word-break":"break-all","text-align":"left"} }
const _hoisted_109 = { key: 5 }
const _hoisted_110 = { key: 0 }
const _hoisted_111 = { key: 1 }
const _hoisted_112 = { style: {"width":"100%","word-break":"break-all","text-align":"left"} }
const _hoisted_113 = { key: 6 }
const _hoisted_114 = { key: 0 }
const _hoisted_115 = { key: 1 }
const _hoisted_116 = { style: {"width":"100%","word-break":"break-all","text-align":"left"} }
const _hoisted_117 = { key: 7 }
const _hoisted_118 = { key: 0 }
const _hoisted_119 = { key: 1 }
const _hoisted_120 = { key: 8 }
const _hoisted_121 = { key: 0 }
const _hoisted_122 = { key: 1 }
const _hoisted_123 = { style: {"width":"100%","word-break":"break-all","text-align":"left"} }
const _hoisted_124 = { key: 9 }
const _hoisted_125 = { key: 0 }
const _hoisted_126 = { key: 1 }
const _hoisted_127 = { key: 0 }
const _hoisted_128 = { key: 2 }
const _hoisted_129 = { key: 10 }
const _hoisted_130 = { key: 0 }
const _hoisted_131 = { key: 0 }
const _hoisted_132 = { key: 1 }
const _hoisted_133 = { key: 1 }
const _hoisted_134 = { key: 11 }
const _hoisted_135 = { key: 0 }
const _hoisted_136 = { key: 1 }
const _hoisted_137 = { key: 12 }
const _hoisted_138 = { key: 0 }
const _hoisted_139 = { key: 1 }
const _hoisted_140 = { key: 13 }
const _hoisted_141 = ["title"]
const _hoisted_142 = { key: 0 }
const _hoisted_143 = ["title"]
const _hoisted_144 = { key: 14 }
const _hoisted_145 = { key: 0 }
const _hoisted_146 = { key: 1 }
const _hoisted_147 = { key: 15 }
const _hoisted_148 = { key: 0 }
const _hoisted_149 = { key: 1 }
const _hoisted_150 = {
  key: 0,
  style: {"margin-left":"5px"}
}
const _hoisted_151 = { key: 1 }
const _hoisted_152 = { key: 2 }
const _hoisted_153 = { key: 16 }
const _hoisted_154 = ["onClick"]
const _hoisted_155 = { key: 17 }
const _hoisted_156 = ["onClick"]
const _hoisted_157 = { key: 18 }
const _hoisted_158 = ["title"]
const _hoisted_159 = { key: 0 }
const _hoisted_160 = { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }
const _hoisted_161 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_162 = {
  ref: "detailFormPie",
  class: "count",
  style: {"width":"100%","height":"300px"}
}
const _hoisted_163 = { style: {"clear":"both","margin-top":"-20px"} }
const _hoisted_164 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_165 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_166 = { key: 0 }
const _hoisted_167 = ["onClick"]
const _hoisted_168 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both","height":"20px"} }, null, -1))
const _hoisted_169 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " 发票信息 ", -1))
const _hoisted_170 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_171 = { style: {"width":"100% !important","overflow":"hidden","height":"26px"} }
const _hoisted_172 = { style: {"width":"100% !important","overflow":"hidden","height":"26px"} }
const _hoisted_173 = { style: {"width":"100% !important","overflow":"hidden","height":"26px"} }
const _hoisted_174 = { style: {"width":"100% !important","overflow":"hidden","height":"26px"} }
const _hoisted_175 = { style: {"width":"100% !important","overflow":"hidden","height":"26px","text-align":"left"} }
const _hoisted_176 = ["href"]
const _hoisted_177 = { style: {"width":"100% !important","overflow":"hidden","height":"26px"} }
const _hoisted_178 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both","height":"20px"} }, null, -1))
const _hoisted_179 = { style: {"clear":"both"} }
const _hoisted_180 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " 核销记录 ", -1))
const _hoisted_181 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_182 = { style: {"width":"100% !important"} }
const _hoisted_183 = { key: 0 }
const _hoisted_184 = { key: 1 }
const _hoisted_185 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_186 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_187 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_188 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_189 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_190 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_191 = { key: 0 }
const _hoisted_192 = { key: 1 }
const _hoisted_193 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_194 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_195 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"float":"left"} }, "历史记录", -1))
const _hoisted_196 = { style: {"float":"right"} }
const _hoisted_197 = { key: 0 }
const _hoisted_198 = { style: {"font-size":"13px"} }
const _hoisted_199 = ["onClick"]
const _hoisted_200 = { style: {"float":"left"} }
const _hoisted_201 = { style: {"font-weight":"900"} }
const _hoisted_202 = { key: 0 }
const _hoisted_203 = {
  key: 0,
  style: {"margin-left":"3px","font-size":"10px","border":"1px solid #aaa","height":"16px","width":"16px","float":"left","text-align":"center","line-height":"16px"}
}
const _hoisted_204 = {
  key: 1,
  style: {"margin-left":"3px","font-size":"10px","border":"1px solid #aaa","height":"16px","width":"16px","float":"left","text-align":"center","line-height":"16px"}
}
const _hoisted_205 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1))
const _hoisted_206 = {
  key: 0,
  style: {"line-height":"28px"}
}
const _hoisted_207 = {
  key: 0,
  style: {"clear":"both"}
}
const _hoisted_208 = {
  key: 0,
  style: {"float":"left","text-indent":"20px"}
}
const _hoisted_209 = {
  key: 1,
  style: {"float":"left"}
}
const _hoisted_210 = {
  key: 0,
  style: {}
}
const _hoisted_211 = { key: 0 }
const _hoisted_212 = {
  key: 0,
  style: {"float":"left","text-indent":"20px"}
}
const _hoisted_213 = { style: {"font-weight":"900"} }
const _hoisted_214 = {
  key: 1,
  style: {"float":"left","text-indent":"20px"}
}
const _hoisted_215 = { style: {"font-weight":"900"} }
const _hoisted_216 = {
  key: 2,
  style: {"float":"left","text-indent":"20px"}
}
const _hoisted_217 = { style: {"font-weight":"900"} }
const _hoisted_218 = {
  key: 3,
  style: {"float":"left","text-indent":"20px"}
}
const _hoisted_219 = { style: {} }
const _hoisted_220 = ["onClick"]
const _hoisted_221 = ["onClick"]
const _hoisted_222 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1))
const _hoisted_223 = { key: 1 }
const _hoisted_224 = { key: 0 }
const _hoisted_225 = { key: 1 }
const _hoisted_226 = {
  key: 0,
  style: {"text-indent":"20px","float":"left"}
}
const _hoisted_227 = { style: {"font-weight":"900"} }
const _hoisted_228 = {
  key: 1,
  style: {"text-indent":"20px","float":"left"}
}
const _hoisted_229 = { style: {"font-weight":"900"} }
const _hoisted_230 = {
  key: 2,
  style: {"text-indent":"20px","float":"left"}
}
const _hoisted_231 = { style: {"font-weight":"900"} }
const _hoisted_232 = {
  key: 3,
  style: {"text-indent":"20px","float":"left"}
}
const _hoisted_233 = { style: {} }
const _hoisted_234 = ["onClick"]
const _hoisted_235 = ["onClick"]
const _hoisted_236 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1))
const _hoisted_237 = { key: 1 }
const _hoisted_238 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1))
const _hoisted_239 = {
  key: 1,
  style: {"clear":"both"}
}
const _hoisted_240 = { key: 0 }
const _hoisted_241 = {
  key: 0,
  style: {"text-indent":"20px"}
}
const _hoisted_242 = { style: {"font-weight":"900"} }
const _hoisted_243 = {
  key: 1,
  style: {"text-indent":"20px"}
}
const _hoisted_244 = { style: {"font-weight":"900"} }
const _hoisted_245 = {
  key: 2,
  style: {"text-indent":"20px"}
}
const _hoisted_246 = { style: {"font-weight":"900"} }
const _hoisted_247 = {
  key: 3,
  style: {"text-indent":"20px"}
}
const _hoisted_248 = { style: {} }
const _hoisted_249 = { key: 1 }
const _hoisted_250 = {
  key: 0,
  style: {"float":"left","text-indent":"20px"}
}
const _hoisted_251 = {
  key: 1,
  style: {"float":"left","text-indent":"20px"}
}
const _hoisted_252 = { style: {"float":"left","text-indent":"20px"} }
const _hoisted_253 = {
  key: 0,
  style: {"text-indent":"20px"}
}
const _hoisted_254 = { style: {"font-weight":"900"} }
const _hoisted_255 = {
  key: 1,
  style: {"text-indent":"20px"}
}
const _hoisted_256 = { style: {"font-weight":"900"} }
const _hoisted_257 = {
  key: 2,
  style: {"text-indent":"20px"}
}
const _hoisted_258 = { style: {"font-weight":"900"} }
const _hoisted_259 = {
  key: 3,
  style: {"text-indent":"20px"}
}
const _hoisted_260 = { style: {} }
const _hoisted_261 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1))
const _hoisted_262 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1))
const _hoisted_263 = {
  key: 1,
  style: {"height":"40px","line-height":"40px","text-align":"center","font-size":"14px","color":"#999"}
}
const _hoisted_264 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both","height":"90px"} }, null, -1))
const _hoisted_265 = { style: {"clear":"both"} }
const _hoisted_266 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " 毛利润明细 ", -1))
const _hoisted_267 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_268 = { style: {"width":"100%"} }
const _hoisted_269 = { style: {"float":"left","width":"50%","line-height":"26px","font-weight":"900","font-size":"13px"} }
const _hoisted_270 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "应收合计：", -1))
const _hoisted_271 = { key: 0 }
const _hoisted_272 = { key: 1 }
const _hoisted_273 = { style: {"float":"left","width":"50%","line-height":"26px","font-weight":"900","font-size":"13px"} }
const _hoisted_274 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "应付合计：", -1))
const _hoisted_275 = { key: 0 }
const _hoisted_276 = { key: 1 }
const _hoisted_277 = {
  key: 2,
  style: {"color":"red","font-weight":"900","padding-left":"10px"}
}
const _hoisted_278 = { style: {"float":"left","width":"50%","line-height":"26px","font-weight":"900","font-size":"13px"} }
const _hoisted_279 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "毛利合计：", -1))
const _hoisted_280 = { key: 0 }
const _hoisted_281 = { key: 1 }
const _hoisted_282 = { style: {"float":"left","width":"50%","line-height":"26px","font-weight":"900","font-size":"13px"} }
const _hoisted_283 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "综合毛利率：", -1))
const _hoisted_284 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_285 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_286 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_287 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_288 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_289 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_290 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_291 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_292 = ["onClick"]
const _hoisted_293 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both","height":"20px"} }, null, -1))
const _hoisted_294 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " 核销记录 ", -1))
const _hoisted_295 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_296 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_297 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_298 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_299 = {
  key: 0,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_300 = {
  key: 1,
  style: {"height":"30px","line-height":"30px"}
}
const _hoisted_301 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_302 = {
  key: 0,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_303 = {
  key: 1,
  style: {"height":"30px","line-height":"30px"}
}
const _hoisted_304 = {
  key: 0,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_305 = {
  key: 1,
  style: {"height":"30px","line-height":"30px"}
}
const _hoisted_306 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_307 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_308 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both","height":"20px"} }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_Document = _resolveComponent("Document")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_ArrowRight = _resolveComponent("ArrowRight")!
  const _component_ArrowLeft = _resolveComponent("ArrowLeft")!
  const _component_miezz_month_choose = _resolveComponent("miezz-month-choose")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_Lock = _resolveComponent("Lock")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_Minus = _resolveComponent("Minus")!
  const _component_miezz_page_list = _resolveComponent("miezz-page-list")!
  const _component_CloseBold = _resolveComponent("CloseBold")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_miezz_button_bar = _resolveComponent("miezz-button-bar")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_ArrowDownBold = _resolveComponent("ArrowDownBold")!
  const _component_ArrowUpBold = _resolveComponent("ArrowUpBold")!
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")!
  const _component_el_timeline = _resolveComponent("el-timeline")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.FinancialManagement_StatisticalAnalysis_Overview == true)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onChangeChannel('0'))),
            style: {"float":"left","width":"50px","cursor":"pointer"}
          }, " 总览 "))
        : _createCommentVNode("", true),
      (_ctx.FinancialManagement_StatisticalAnalysis_SalespersonRelated == true)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onChangeChannel('1'))),
            style: {"float":"left","width":"90px","cursor":"pointer"}
          }, " 业务员相关 "))
        : _createCommentVNode("", true),
      (_ctx.FinancialManagement_StatisticalAnalysis_CustomerRelated == true)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, " 客户相关 "))
        : _createCommentVNode("", true),
      (_ctx.type!='2')
        ? (_openBlock(), _createElementBlock("div", _hoisted_4))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.isFinancialCycle==false)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              style: {"cursor":"pointer"},
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onTime()))
            }, "切换至财务周期"))
          : _createCommentVNode("", true),
        (_ctx.isFinancialCycle==true)
          ? (_openBlock(), _createElementBlock("span", {
              key: 1,
              style: {"cursor":"pointer"},
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onTime()))
            }, "切换至业务周期"))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_ctx.isLeft==false)
        ? (_openBlock(), _createBlock(_component_el_card, {
            key: 0,
            class: "left"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_el_form, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, { label: "客户企业" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            "no-data-text": '无匹配信息',
                            "no-match-text": '无匹配信息',
                            onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onChangeSelectCompany())),
                            modelValue: _ctx.companyId,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.companyId) = $event)),
                            filterable: "",
                            placeholder: "请选择"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companys, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.Value,
                                  label: item.Label,
                                  value: item.Value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                (_ctx.FinancialManagement_StatisticalAnalysis_CustomerRelated_CollectionProgress==true)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "el-alert el-alert--info is-dark",
                      style: _normalizeStyle(_ctx.type == '0' ? 'background-color: #00a9fc;color:#fff;' : ''),
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onChangeType('0')))
                    }, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("span", _hoisted_10, [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Document)
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" 收款进度 ")
                        ])
                      ])
                    ], 4))
                  : _createCommentVNode("", true),
                (_ctx.FinancialManagement_StatisticalAnalysis_CustomerRelated_CostList==true)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "el-alert el-alert--info is-dark",
                      style: _normalizeStyle(_ctx.type == '2' ? 'background-color: #00a9fc;color:#fff;' : ''),
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onChangeType('2')))
                    }, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("span", _hoisted_12, [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Document)
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" 应收账单 ")
                        ])
                      ])
                    ], 4))
                  : _createCommentVNode("", true),
                (_ctx.FinancialManagement_StatisticalAnalysis_CustomerRelated_GrossProfit==true)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 2,
                      class: "el-alert el-alert--info is-dark",
                      style: _normalizeStyle(_ctx.type == '3' ? 'background-color: #00a9fc;color:#fff;' : ''),
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onChangeType('3')))
                    }, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("span", _hoisted_14, [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Document)
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" 毛利润 ")
                        ])
                      ])
                    ], 4))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.isLeft==true?'middle':'isMiddle'),
        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.isLeft = !_ctx.isLeft))
      }, [
        (_ctx.isLeft == true)
          ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_ArrowRight)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.isLeft == false)
          ? (_openBlock(), _createBlock(_component_el_icon, { key: 1 }, {
              default: _withCtx(() => [
                _createVNode(_component_ArrowLeft)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.isLeft==false?'right':'isRight')
      }, [
        _createVNode(_component_miezz_month_choose, {
          modelValue: _ctx.month,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.month) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_el_card, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_15, [
              (_ctx.type == '0' || _ctx.type == '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, "收款进度"))
                : (_ctx.type == '1')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, "付款进度"))
                  : (_ctx.type == '2')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, "应收账单"))
                    : (_ctx.type == '3')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, "毛利润"))
                      : (_ctx.type == '4')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, "实际利润"))
                        : _createCommentVNode("", true),
              (_ctx.type == '3' && _ctx.result.Rate!=null && _ctx.result.Rate!=undefined && _ctx.result.Rate!='')
                ? (_openBlock(), _createElementBlock("span", _hoisted_21, " 参考汇率 " + _toDisplayString(_ctx.result.Rate), 1))
                : _createCommentVNode("", true),
              (_ctx.type == '2')
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createVNode(_component_el_button, {
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.onBillDetail())),
                      size: "small",
                      type: "primary"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("查看详情")
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              (_ctx.type=='0')
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(_ctx.result.Credit), 1))
                : _createCommentVNode("", true),
              (_ctx.type == '3')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 8,
                    style: {"color":"#f6a46d","cursor":"pointer","float":"right"},
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.onGrossProfitDetail()))
                  }, " 查看明细 "))
                : _createCommentVNode("", true),
              ((_ctx.type == '0' || _ctx.type == '' || _ctx.type == '1') && _ctx.isFinancialCycle!=true)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 9,
                    style: {"color":"#f6a46d","cursor":"pointer","margin-left":"10px"},
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.onNoBill()))
                  }, " 委托书（无账单）票数：" + _toDisplayString(_ctx.result.PoolCount), 1))
                : _createCommentVNode("", true)
            ]),
            (_ctx.type=='3' || _ctx.type=='4')
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  (_ctx.type=='3' && _ctx.isGrossProfitChart==true)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, null, 512))
                    : _createCommentVNode("", true),
                  (_ctx.result.Profit != _ctx.nul && _ctx.result.Profit.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.result.Profit, (p, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            style: {"clear":"both","margin-top":"10px","border-bottom":"1px solid #eee","padding-bottom":"50px"},
                            key: index
                          }, [
                            _createElementVNode("div", _hoisted_27, [
                              _createElementVNode("div", _hoisted_28, [
                                _hoisted_29,
                                _createElementVNode("div", _hoisted_30, _toDisplayString(p.CurrencySystemCode), 1)
                              ]),
                              _createElementVNode("div", _hoisted_31, [
                                _hoisted_32,
                                _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.formatNumber(p.Profit)), 1),
                                _createElementVNode("div", {
                                  style: {"color":"#f6a46d","cursor":"pointer","float":"left","width":"150px"},
                                  onClick: ($event: any) => (
                    _ctx.onBill(
                      7,
                      p.CurrencySystemId
                    )
                  )
                                }, " 查看明细 ", 8, _hoisted_34),
                                (_ctx.currencySystem?.ShowTaxRate)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, " 应收税额： "))
                                  : _createCommentVNode("", true),
                                (_ctx.currencySystem?.ShowTaxRate)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(_ctx.formatNumber(p.CollectionTaxAmount)), 1))
                                  : _createCommentVNode("", true),
                                (_ctx.currencySystem?.ShowTaxRate)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, " 应付税额： "))
                                  : _createCommentVNode("", true),
                                (_ctx.currencySystem?.ShowTaxRate)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString(_ctx.formatNumber(p.PaymentTaxAmount)), 1))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ]))
                        }), 128)),
                        _createElementVNode("div", _hoisted_39, [
                          _createTextVNode(" 合计：CNY " + _toDisplayString(_ctx.formatNumber(_ctx.result.Total)) + " ", 1),
                          _createElementVNode("span", {
                            style: {"color":"#f6a46d","cursor":"pointer","margin-left":"20px"},
                            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.onSumLink()))
                          }, " 查看明细 "),
                          _hoisted_40,
                          (_ctx.type=='3')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_41, "已核销利润（已核销应收金额-已核销应付金额，折算为CNY得出）：CNY " + _toDisplayString(_ctx.formatNumber(_ctx.result.RealityProfit)), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_42, " 暂无数据 "))
                ]))
              : _createCommentVNode("", true),
            (_ctx.type=='0' || _ctx.type=='1')
              ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                  (_ctx.result.Item != _ctx.nul && _ctx.result.Item.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.result.Item, (p, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            style: {"clear":"both","margin-top":"10px","border-bottom":"1px solid #eee","padding-bottom":"50px"},
                            key: index
                          }, [
                            _createElementVNode("div", _hoisted_45, [
                              _createVNode(_component_el_progress, {
                                "text-inside": true,
                                "stroke-width": 22,
                                percentage: p.Progress
                              }, null, 8, ["percentage"])
                            ]),
                            _createElementVNode("div", _hoisted_46, [
                              _createElementVNode("div", _hoisted_47, [
                                _hoisted_48,
                                _createElementVNode("div", _hoisted_49, _toDisplayString(p.CurrencySystemCode), 1)
                              ]),
                              _createElementVNode("div", _hoisted_50, [
                                _hoisted_51,
                                _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.formatNumber(p.Total)), 1),
                                _createElementVNode("div", {
                                  style: {"color":"#f6a46d","cursor":"pointer","float":"left"},
                                  onClick: ($event: any) => (
                    _ctx.onBill(
                      0,
                      p.CurrencySystemId
                    )
                  )
                                }, " 查看明细 ", 8, _hoisted_53)
                              ]),
                              _createElementVNode("div", _hoisted_54, [
                                _hoisted_55,
                                _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.formatNumber(p.Invoice)), 1),
                                _createElementVNode("div", {
                                  style: {"color":"#f6a46d","cursor":"pointer","float":"left"},
                                  onClick: ($event: any) => (
                    _ctx.onBill(
                      1,
                      p.CurrencySystemId
                    )
                  )
                                }, " 查看明细 ", 8, _hoisted_57)
                              ]),
                              _createElementVNode("div", _hoisted_58, [
                                _hoisted_59,
                                _createElementVNode("div", _hoisted_60, _toDisplayString(_ctx.formatNumber(p.NoInvoice)), 1),
                                _createElementVNode("div", {
                                  style: {"color":"#f6a46d","cursor":"pointer","float":"left"},
                                  onClick: ($event: any) => (
                    _ctx.onBill(
                      2,
                      p.CurrencySystemId
                    )
                  )
                                }, " 查看明细 ", 8, _hoisted_61)
                              ]),
                              _createElementVNode("div", _hoisted_62, [
                                _hoisted_63,
                                _createElementVNode("div", _hoisted_64, _toDisplayString(_ctx.formatNumber(p.Settlement)), 1),
                                _createElementVNode("div", {
                                  style: {"color":"#f6a46d","cursor":"pointer","float":"left"},
                                  onClick: ($event: any) => (
                    _ctx.onBill(
                      3,
                      p.CurrencySystemId
                    )
                  )
                                }, " 查看明细 ", 8, _hoisted_65),
                                _hoisted_66,
                                _createElementVNode("div", _hoisted_67, _toDisplayString(_ctx.formatNumber(p.SettlementOverdue)), 1),
                                _createElementVNode("div", {
                                  style: {"color":"#f6a46d","cursor":"pointer","float":"left"},
                                  onClick: ($event: any) => (
                    _ctx.onBill(
                      5,
                      p.CurrencySystemId
                    )
                  )
                                }, " 查看明细 ", 8, _hoisted_68),
                                _hoisted_69,
                                _createElementVNode("div", _hoisted_70, _toDisplayString(_ctx.formatNumber(p.BadSettlement)), 1),
                                _createElementVNode("div", {
                                  style: {"color":"#f6a46d","cursor":"pointer","float":"left","width":"150px"},
                                  onClick: ($event: any) => (
                    _ctx.onBill(
                      8,
                      p.CurrencySystemId
                    )
                  )
                                }, " 查看明细 ", 8, _hoisted_71),
                                _createElementVNode("div", {
                                  style: {"color":"#f6a46d","cursor":"pointer","float":"left","font-size":"14px"},
                                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.onSettlementList()))
                                }, " 核销记录 ")
                              ]),
                              _createElementVNode("div", _hoisted_72, [
                                _hoisted_73,
                                _createElementVNode("div", _hoisted_74, _toDisplayString(_ctx.formatNumber(p.NoSettlement)), 1),
                                _createElementVNode("div", {
                                  style: {"color":"#f6a46d","cursor":"pointer","float":"left"},
                                  onClick: ($event: any) => (
                    _ctx.onBill(
                      4,
                      p.CurrencySystemId,
                    )
                  )
                                }, " 查看明细 ", 8, _hoisted_75),
                                _hoisted_76,
                                _createElementVNode("div", _hoisted_77, _toDisplayString(_ctx.formatNumber(p.NoSettlementOverdue)), 1),
                                _createElementVNode("div", {
                                  style: {"color":"#f6a46d","cursor":"pointer","float":"left"},
                                  onClick: ($event: any) => (
                    _ctx.onBill(
                      6,
                      p.CurrencySystemId
                    )
                  )
                                }, " 查看明细 ", 8, _hoisted_78)
                              ])
                            ])
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_79, " 暂无数据 "))
                ]))
              : (_ctx.type=='2')
                ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                    _createElementVNode("div", _hoisted_81, [
                      _createVNode(_component_miezz_page_list, {
                        modelValue: _ctx.list,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.list) = $event)),
                        ref: "$FinanceTable"
                      }, {
                        column: _withCtx(({ model,row }) => [
                          (model.Prop == 'BookingNo')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_82, [
                                ((row.BookingNo!=null && row.BookingNo!=undefined) && row.IsSave == true && (row.FromId==null || row.FromId==undefined || row.FromId==''))
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 0,
                                      title: "账单已锁定",
                                      style: {"padding-right":"5px"},
                                      class: _normalizeClass(row.Pool && row.Pool.Status == 40 ? 'err' : 'warn' )
                                    }, [
                                      _createVNode(_component_el_icon, { class: "warn" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Lock)
                                        ]),
                                        _: 1
                                      })
                                    ], 2))
                                  : ((row.BookingNo!=null && row.BookingNo!=undefined) && row.IsLock == true && (row.FromId==null || row.FromId==undefined || row.FromId==''))
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 1,
                                        title: "订单已锁定",
                                        style: {"padding-right":"5px"},
                                        class: _normalizeClass(row.Pool && row.Pool.Status == 40 ? 'err' : 'warn' )
                                      }, [
                                        _createVNode(_component_el_icon, { class: "err" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_Lock)
                                          ]),
                                          _: 1
                                        })
                                      ], 2))
                                    : _createCommentVNode("", true),
                                (row.BookingNo==null || row.BookingNo==undefined)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_83, [
                                      (row.Type == 20)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_84, [
                                            (row.IsLock == true && (row.FromId==null || row.FromId==undefined || row.FromId==''))
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_85, [
                                                  _createElementVNode("span", {
                                                    style: _normalizeStyle([{"padding-right":"5px","margin-left":"-20px"}, (row.Child==null || row.Child==undefined || row.Child.length<=0) && (row.PoolId==undefined || row.PoolId==null || row.PoolId=='')?'margin-left:0px;':''])
                                                  }, [
                                                    _createVNode(_component_el_icon, { class: "err" }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_Lock)
                                                      ]),
                                                      _: 1
                                                    })
                                                  ], 4)
                                                ]))
                                              : (row.IsSave == true && (row.FromId==null || row.FromId==undefined || row.FromId==''))
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_86, [
                                                    _createElementVNode("span", {
                                                      style: _normalizeStyle([{"padding-right":"5px","margin-left":"-20px"}, (row.Child==null || row.Child==undefined || row.Child.length<=0) && (row.PoolId==undefined || row.PoolId==null || row.PoolId=='')?'margin-left:0px;':''])
                                                    }, [
                                                      _createVNode(_component_el_icon, { class: "warn" }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_Lock)
                                                        ]),
                                                        _: 1
                                                      })
                                                    ], 4)
                                                  ]))
                                                : _createCommentVNode("", true),
                                            (row.Child!=null && row.Child!=undefined && row.Child.length>0)
                                              ? (_openBlock(), _createElementBlock("span", {
                                                  key: 2,
                                                  onClick: ($event: any) => (_ctx.onChild(row)),
                                                  style: {"cursor":"pointer"}
                                                }, [
                                                  (row.IsOpen==false)
                                                    ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_Plus)
                                                        ]),
                                                        _: 1
                                                      }))
                                                    : (_openBlock(), _createBlock(_component_el_icon, { key: 1 }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_Minus)
                                                        ]),
                                                        _: 1
                                                      })),
                                                  _createTextVNode(" 已分摊 ")
                                                ], 8, _hoisted_87))
                                              : (_openBlock(), _createElementBlock("span", _hoisted_88, " 未分摊 "))
                                          ]))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_89, [
                                            (row.IsSave == true && (row.FromId==null || row.FromId==undefined || row.FromId==''))
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_90, [
                                                  _createVNode(_component_el_icon, { class: "warn" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_Lock)
                                                    ]),
                                                    _: 1
                                                  })
                                                ]))
                                              : (row.IsLock == true && (row.FromId==null || row.FromId==undefined || row.FromId==''))
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_91, [
                                                    _createVNode(_component_el_icon, { class: "err" }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_Lock)
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]))
                                                : _createCommentVNode("", true),
                                            _createTextVNode(" 暂无数据 ")
                                          ]))
                                    ]))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_92, _toDisplayString(row.BookingNo), 1))
                              ]))
                            : _createCommentVNode("", true),
                          (model.Prop == 'Code')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_93, [
                                (row.Code==null || row.Code==undefined)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_94, "暂无数据"))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_95, [
                                      _createElementVNode("span", _hoisted_96, _toDisplayString(row.Code), 1)
                                    ]))
                              ]))
                            : _createCommentVNode("", true),
                          (model.Prop == 'BLNO')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_97, [
                                (row.BLNO==null || row.BLNO==undefined)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_98, "暂无数据"))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_99, [
                                      _createElementVNode("span", _hoisted_100, _toDisplayString(row.BLNO), 1)
                                    ]))
                              ]))
                            : _createCommentVNode("", true),
                          (model.Prop == 'ETD')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_101, [
                                (row.ETD==null || row.ETD==undefined || row.ETD=='')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_102, "暂无数据"))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_103, [
                                      _createElementVNode("span", _hoisted_104, _toDisplayString(row.ETD), 1)
                                    ]))
                              ]))
                            : _createCommentVNode("", true),
                          (model.Prop == 'ATD')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_105, [
                                (row.ATD==null || row.ATD==undefined || row.ATD=='')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_106, "暂无数据"))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_107, [
                                      _createElementVNode("span", _hoisted_108, _toDisplayString(row.ATD), 1)
                                    ]))
                              ]))
                            : _createCommentVNode("", true),
                          (model.Prop == 'ETA')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_109, [
                                (row.ETA==null || row.ETA==undefined || row.ETA=='')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_110, "暂无数据"))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_111, [
                                      _createElementVNode("span", _hoisted_112, _toDisplayString(row.ETA), 1)
                                    ]))
                              ]))
                            : _createCommentVNode("", true),
                          (model.Prop == 'ATA')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_113, [
                                (row.ATA==null || row.ATA==undefined || row.ATA=='')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_114, "暂无数据"))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_115, [
                                      _createElementVNode("span", _hoisted_116, _toDisplayString(row.ATA), 1)
                                    ]))
                              ]))
                            : _createCommentVNode("", true),
                          (model.Prop == 'BillObject')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_117, [
                                ( row.BillObject!=null && row.BillObject!=undefined && row.BillObject!='')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_118, _toDisplayString(row.BillObject), 1))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_119, "暂无数据"))
                              ]))
                            : _createCommentVNode("", true),
                          (model.Prop == 'SalerName')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_120, [
                                (row.SalerName==null || row.SalerName==undefined)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_121, "暂无数据"))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_122, [
                                      _createElementVNode("span", _hoisted_123, _toDisplayString(row.SalerName), 1)
                                    ]))
                              ]))
                            : _createCommentVNode("", true),
                          (model.Prop == 'UnitPrice')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_124, [
                                (row.FromId!=null && row.FromId!=undefined && row.FromId!='')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_125, "—"))
                                  : ( row.UnitPrice!=null && row.UnitPrice!=undefined && row.UnitPrice!='')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_126, [
                                        (row.CurrencySystem!=null && row.CurrencySystem!=undefined)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_127, _toDisplayString(row.CurrencySystem.Code), 1))
                                          : _createCommentVNode("", true),
                                        _createTextVNode(_toDisplayString(row.UnitPrice), 1)
                                      ]))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_128, "暂无数据"))
                              ]))
                            : _createCommentVNode("", true),
                          (model.Prop == 'CostId')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_129, [
                                (row.Cost!=null && row.Cost!=undefined)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_130, [
                                      (row.Cost!=null)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_131, _toDisplayString(row.Cost.NameZh), 1))
                                        : _createCommentVNode("", true),
                                      (row.FromId!=null&&row.FromId!=undefined)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_132, "分摊"))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_133, "暂无数据"))
                              ]))
                            : _createCommentVNode("", true),
                          (model.Prop == 'CurrencySystemId')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_134, [
                                (row.CurrencySystem!=null && row.CurrencySystem!=undefined)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_135, _toDisplayString(row.CurrencySystem.Code), 1))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_136, "暂无数据"))
                              ]))
                            : _createCommentVNode("", true),
                          (model.Prop == 'Remark')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_137, [
                                (row.Remark!=null && row.Remark!=undefined && row.Remark!='')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_138, _toDisplayString(row.Remark), 1))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_139, "暂无数据"))
                              ]))
                            : _createCommentVNode("", true),
                          (model.Prop == 'TotalPrice')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_140, [
                                (row.TotalPrice!=null && row.TotalPrice!=undefined && row.TotalPrice!='')
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 0,
                                      style: _normalizeStyle(row.IsSave!=true?'color:red;':''),
                                      title: row.IsSave!=true?'该账单还没保存':''
                                    }, [
                                      (row.CurrencySystem!=null && row.CurrencySystem!=undefined)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_142, _toDisplayString(row.CurrencySystem.Code), 1))
                                        : _createCommentVNode("", true),
                                      _createTextVNode(_toDisplayString(_ctx.formatNumber(row.TotalPrice)), 1)
                                    ], 12, _hoisted_141))
                                  : (_openBlock(), _createElementBlock("span", {
                                      key: 1,
                                      style: _normalizeStyle(row.IsSave!=true?'color:red;':''),
                                      title: row.IsSave!=true?'该账单还没保存':''
                                    }, "暂无数据", 12, _hoisted_143))
                              ]))
                            : _createCommentVNode("", true),
                          (model.Prop == 'StartDateString')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_144, [
                                (row.StartDateString!=null && row.StartDate!=undefined && row.StartDateString!='')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_145, _toDisplayString(row.StartDateString), 1))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_146, "暂无数据"))
                              ]))
                            : _createCommentVNode("", true),
                          (model.Prop == 'FirstChargeUnitNumber')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_147, [
                                (row.FromId!=null && row.FromId!=undefined && row.FromId!='')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_148, "—"))
                                  : (row.FirstChargeUnitNumber!=null && row.FirstChargeUnitNumber!=undefined || (row.FirstChargeUnit!=null && row.FirstChargeUnit!=undefined))
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_149, [
                                        (row.FirstChargeUnit!=null && row.FirstChargeUnit!=undefined)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_150, _toDisplayString(row.FirstChargeUnit.FullName), 1))
                                          : _createCommentVNode("", true),
                                        (row.FirstChargeUnitNumber!=null && row.FirstChargeUnitNumber!=undefined)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_151, "×" + _toDisplayString(row.FirstChargeUnitNumber), 1))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_152, "暂无数据"))
                              ]))
                            : _createCommentVNode("", true),
                          (model.Prop == 'InvoiceNumber')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_153, [
                                _createElementVNode("div", {
                                  onClick: ($event: any) => (_ctx.onInvoice(row)),
                                  style: {"cursor":"pointer","color":"#fe995b","overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap"}
                                }, _toDisplayString(_ctx.isString(row.InvoiceNumber)), 9, _hoisted_154)
                              ]))
                            : _createCommentVNode("", true),
                          (model.Prop == 'SettlementType')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_155, [
                                _createElementVNode("div", {
                                  onClick: ($event: any) => (_ctx.onSettlement(row)),
                                  style: {"cursor":"pointer","color":"#fe995b","overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap"}
                                }, _toDisplayString(_ctx.isString(row.SettlementTypeString)), 9, _hoisted_156)
                              ]))
                            : _createCommentVNode("", true),
                          (model.Prop == 'AccountPeriodString')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_157, [
                                _createElementVNode("div", {
                                  title: (row.StartDateString!=null && row.StartDate!=undefined && row.StartDateString!='')?('记账起始日期：' + row.StartDateString):'',
                                  style: _normalizeStyle(row.SurplusDays<0?'color:red;':'')
                                }, [
                                  _createTextVNode(_toDisplayString(_ctx.isString(row.AccountPeriod)) + " ", 1),
                                  (row.SurplusDayString!=null && row.SurplusDayString!=undefined && row.SurplusDayString!='')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_159, "/" + _toDisplayString(row.SurplusDayString), 1))
                                    : _createCommentVNode("", true)
                                ], 12, _hoisted_158)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ], 2)
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.detailForm.Visible,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.detailForm.Visible) = $event)),
      "show-close": false,
      style: {"width":"60%"},
      top: "10px",
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "append-to-body": true
    }, {
      header: _withCtx(({ close }) => [
        _createElementVNode("div", _hoisted_160, _toDisplayString(_ctx.detailForm.Title), 1),
        _createElementVNode("div", _hoisted_161, [
          _createVNode(_component_el_icon, {
            style: {"cursor":"pointer"},
            onClick: close
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CloseBold)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_162, null, 512),
        _createElementVNode("div", _hoisted_163, [
          _createVNode(_component_el_table, {
            border: "",
            "tree-props": {children: 'Child', hasChildren: 'hasChildren'},
            "row-key": "Id",
            "default-expand-all": false,
            data: _ctx.detailForm.Details,
            ref: "$billTable",
            style: {"width":"100%","margin-top":"15px"},
            "header-cell-style": { 'text-align': 'left' },
            "cell-style": { 'text-align': 'left' }
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "scope.row.Name",
                label: _ctx.CompositionType==7?'委托人':'对账对象',
                "show-overflow-tooltip": true
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_164, _toDisplayString(_ctx.isString(scope.row.Name)), 1)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                prop: "scope.row.Value",
                label: "金额（元）",
                "show-overflow-tooltip": true
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_165, [
                    _createTextVNode(_toDisplayString(_ctx.isString(scope.row.Value)) + " ", 1),
                    (scope.row.StatPrice!=undefined && scope.row.StatPrice!=null && scope.row.StatPrice!='')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_166, "( " + _toDisplayString(scope.row.StatPrice) + ")", 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "scope.row.Collection",
                label: "操作",
                "show-overflow-tooltip": true,
                width: "100"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    onClick: ($event: any) => (_ctx.onClientDetail(scope.row)),
                    style: {"cursor":"pointer","color":"#fe995b","width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
                  }, " 查看账单 ", 8, _hoisted_167)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])
        ]),
        _hoisted_168,
        _createVNode(_component_miezz_button_bar, {
          modelValue: _ctx.detailBottomButtons,
          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.detailBottomButtons) = $event)),
          isBackground: true,
          onHandleClick: _ctx.handleClickDetail
        }, null, 8, ["modelValue", "onHandleClick"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_ctx.invoiceForm != undefined)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 0,
          modelValue: _ctx.invoiceForm.Visiable,
          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.invoiceForm.Visiable) = $event)),
          "show-close": false,
          style: {"width":"70%"},
          top: "10px",
          "close-on-click-modal": false,
          "close-on-press-escape": false,
          "append-to-body": true
        }, {
          header: _withCtx(({ close }) => [
            _hoisted_169,
            _createElementVNode("div", _hoisted_170, [
              _createVNode(_component_el_icon, {
                style: {"cursor":"pointer"},
                onClick: close
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CloseBold)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_el_form, {
                ref: "refInvoiceForm",
                model: _ctx.invoiceForm
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table, {
                    ref: "invoiceTable",
                    data: _ctx.invoiceForm.InvoiceItems
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, {
                        prop: "Number",
                        width: "220",
                        label: "发票号码"
                      }, {
                        default: _withCtx((scope) => [
                          _createElementVNode("div", _hoisted_171, _toDisplayString(scope.row.Number), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "CollectionTitle",
                        label: "收款方发票抬头"
                      }, {
                        default: _withCtx((scope) => [
                          _createElementVNode("div", _hoisted_172, _toDisplayString(scope.row.CollectionTitle), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "PaymentTitle",
                        label: "付款方发票抬头"
                      }, {
                        default: _withCtx((scope) => [
                          _createElementVNode("div", _hoisted_173, _toDisplayString(scope.row.PaymentTitle), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "InvoiceDate",
                        width: "140",
                        label: "开票日期"
                      }, {
                        default: _withCtx((scope) => [
                          _createElementVNode("div", _hoisted_174, _toDisplayString(scope.row.InvoiceDateString), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "Annexs",
                        width: "70",
                        label: "凭证"
                      }, {
                        default: _withCtx((scope) => [
                          _createElementVNode("div", _hoisted_175, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.Annexs, (p, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                style: {"line-height":"26px"},
                                key: index
                              }, [
                                _createElementVNode("a", {
                                  style: {"color":"#409eff","text-decoration":"none"},
                                  target: "_blank",
                                  href: p.Url
                                }, [
                                  _createVNode(_component_el_icon, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Document)
                                    ]),
                                    _: 1
                                  })
                                ], 8, _hoisted_176)
                              ]))
                            }), 128))
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "Remark",
                        label: "备注"
                      }, {
                        default: _withCtx((scope) => [
                          _createElementVNode("div", _hoisted_177, _toDisplayString(scope.row.Remark), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["data"])
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            _hoisted_178,
            _createElementVNode("div", _hoisted_179, [
              _createVNode(_component_miezz_button_bar, {
                modelValue: _ctx.invoiceBottomButtons,
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.invoiceBottomButtons) = $event)),
                isBackground: true,
                onHandleClick: _ctx.handleClickInvoice
              }, null, 8, ["modelValue", "onHandleClick"])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (_ctx.settlementForm != undefined)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 1,
          modelValue: _ctx.settlementForm.Visiable,
          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.settlementForm.Visiable) = $event)),
          "show-close": false,
          style: {"width":"90%"},
          "close-on-click-modal": false,
          "close-on-press-escape": false,
          top: "0px",
          "append-to-body": true
        }, {
          header: _withCtx(({ close }) => [
            _hoisted_180,
            _createElementVNode("div", _hoisted_181, [
              _createVNode(_component_el_icon, {
                style: {"cursor":"pointer"},
                onClick: close
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CloseBold)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_182, [
              _createVNode(_component_el_card, { style: {"margin-top":"5px"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form, {
                    ref: "refSettlementForm",
                    model: _ctx.settlementForm,
                    rules: _ctx.settlementRules
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: "总金额",
                        style: {"margin-top":"0px"},
                        "label-width": "100px"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.settlementForm.CurrencySystemCode) + _toDisplayString(_ctx.settlementForm.Total), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "待核销",
                        style: {"margin-top":"-10px"},
                        "label-width": "100px"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.settlementForm.CurrencySystemCode) + _toDisplayString(_ctx.settlementForm.NoSettlementPrice), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "已核销",
                        style: {"margin-top":"-10px"},
                        "label-width": "100px"
                      }, {
                        default: _withCtx(() => [
                          (_ctx.settlementForm.SettlementPrice!=null && _ctx.settlementForm.SettlementPrice!=undefined && _ctx.settlementForm.SettlementPrice!='')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_183, _toDisplayString(_ctx.settlementForm.SettlementPrice), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_184, "CNY0"))
                        ]),
                        _: 1
                      }),
                      (_openBlock(), _createBlock(_component_el_table, {
                        ref: "settlementTable",
                        key: _ctx.settlementTableRandom,
                        data: _ctx.settlementForm.Items
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_table_column, {
                            prop: "Price",
                            "show-overflow-tooltip": true,
                            label: "核销金额"
                          }, {
                            default: _withCtx((scope) => [
                              _createElementVNode("div", _hoisted_185, _toDisplayString(scope.row.CurrencySystem.Code) + _toDisplayString(scope.row.Price), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "DisplayRate",
                            width: "90px",
                            "show-overflow-tooltip": true,
                            label: "汇率"
                          }, {
                            default: _withCtx((scope) => [
                              _createElementVNode("div", _hoisted_186, _toDisplayString(scope.row.DisplayRate), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "SettlementDateString",
                            "show-overflow-tooltip": true,
                            label: "核销时间"
                          }, {
                            default: _withCtx((scope) => [
                              _createElementVNode("div", _hoisted_187, _toDisplayString(scope.row.SettlementDateString), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "CollectionTitle",
                            "show-overflow-tooltip": true,
                            label: "收款方"
                          }, {
                            default: _withCtx((scope) => [
                              _createElementVNode("div", _hoisted_188, _toDisplayString(scope.row.CollectionTitle), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "PaymentTitle",
                            "show-overflow-tooltip": true,
                            label: "付款方"
                          }, {
                            default: _withCtx((scope) => [
                              _createElementVNode("div", _hoisted_189, _toDisplayString(scope.row.PaymentTitle), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "Mode",
                            "show-overflow-tooltip": true,
                            label: "核销方式"
                          }, {
                            default: _withCtx((scope) => [
                              _createElementVNode("div", _hoisted_190, [
                                (scope.row.Mode == 10)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_191, "对公银行"))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_192, "现金/私人银行/其他"))
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "Remark",
                            "show-overflow-tooltip": true,
                            label: "备注"
                          }, {
                            default: _withCtx((scope) => [
                              _createElementVNode("div", _hoisted_193, _toDisplayString(scope.row.Remark), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "CreatedUserName",
                            "show-overflow-tooltip": true,
                            label: "创建人"
                          }, {
                            default: _withCtx((scope) => [
                              _createElementVNode("div", _hoisted_194, _toDisplayString(scope.row.CreatedUserName), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["data"]))
                    ]),
                    _: 1
                  }, 8, ["model", "rules"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_card, { style: {"margin-top":"5px","display":"none"} }, {
                header: _withCtx(() => [
                  _createElementVNode("div", {
                    style: {"width":"100% !important","cursor":"pointer","height":"50px","line-height":"50px"},
                    onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.isHistory = !_ctx.isHistory))
                  }, [
                    _hoisted_195,
                    _createElementVNode("div", _hoisted_196, [
                      (_ctx.isHistory==false)
                        ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ArrowDownBold)
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_el_icon, { key: 1 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ArrowUpBold)
                            ]),
                            _: 1
                          }))
                    ])
                  ]),
                  (_ctx.isHistory==false)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_197, [
                        (_ctx.historys.Data.Items!=null && _ctx.historys.Data.Items != undefined && _ctx.historys.Data.Items.length>0)
                          ? (_openBlock(), _createBlock(_component_el_timeline, { key: 0 }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.historys.Data.Items, (activity, index) => {
                                  return (_openBlock(), _createBlock(_component_el_timeline_item, {
                                    key: index,
                                    timestamp: activity.CreatedTime,
                                    "hide-timestamp": true
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_198, [
                                        _createElementVNode("div", {
                                          style: {"cursor":"pointer"},
                                          onClick: ($event: any) => (activity.IsOpen = !activity.IsOpen)
                                        }, [
                                          _createElementVNode("div", _hoisted_200, [
                                            _createTextVNode(_toDisplayString(activity.CreatedTime) + " 由", 1),
                                            _createElementVNode("span", _hoisted_201, _toDisplayString(activity.CreatedUserName) + "（" + _toDisplayString(activity.CreatedCompanyNameZh) + "）", 1),
                                            _createTextVNode(_toDisplayString(activity.Title), 1),
                                            (activity.NewLabel!=null && activity.NewLabel!=undefined && activity.NewLabel!='')
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_202, "（" + _toDisplayString(activity.NewLabel) + "）", 1))
                                              : _createCommentVNode("", true)
                                          ]),
                                          (activity.IsOpen==false && activity.Child!=null && activity.Child!=undefined && activity.Child.length>0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_203, [
                                                _createVNode(_component_el_icon, null, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_Plus)
                                                  ]),
                                                  _: 1
                                                })
                                              ]))
                                            : _createCommentVNode("", true),
                                          (activity.IsOpen==true && activity.Child!=null && activity.Child!=undefined && activity.Child.length>0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_204, [
                                                _createVNode(_component_el_icon, null, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_Minus)
                                                  ]),
                                                  _: 1
                                                })
                                              ]))
                                            : _createCommentVNode("", true),
                                          _hoisted_205
                                        ], 8, _hoisted_199),
                                        (activity.Child!=null && activity.Child!=undefined && activity.Child.length>0 && activity.IsOpen==true)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_206, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activity.Child, (p, index1) => {
                                                return (_openBlock(), _createElementBlock("div", { key: index1 }, [
                                                  (p.Title!=null && p.Title!=undefined && p.Title!='')
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_207, [
                                                        (p.Child!=null && p.Child!=undefined && p.Child.length>0)
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_208, _toDisplayString(p.Title), 1))
                                                          : _createCommentVNode("", true),
                                                        (p.Child!=null && p.Child!=undefined && p.Child.length>0)
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_209, [
                                                              (p.Child!=null && p.Child!=undefined && p.Child.length>0)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_210, [
                                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p.Child, (p2, index2) => {
                                                                      return (_openBlock(), _createElementBlock("div", { key: index2 }, [
                                                                        (p2.Child==null || p2.Child==undefined || p2.Child.length<=0)
                                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_211, [
                                                                              (p2.State==4 && (index2==0 || p.IsOpen==true))
                                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_212, [
                                                                                    _createTextVNode("新增了"),
                                                                                    _createElementVNode("span", _hoisted_213, _toDisplayString(p2.Label), 1),
                                                                                    _createTextVNode("，新值为\"" + _toDisplayString(p2.NewLabel) + "\"", 1)
                                                                                  ]))
                                                                                : _createCommentVNode("", true),
                                                                              (p2.State==3 && (index2==0 || p.IsOpen==true))
                                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_214, [
                                                                                    _createTextVNode("编辑了"),
                                                                                    _createElementVNode("span", _hoisted_215, _toDisplayString(p2.Label), 1),
                                                                                    _createTextVNode("，由\"" + _toDisplayString(p2.OldLabel) + "\"改为\"" + _toDisplayString(p2.NewLabel) + "\"", 1)
                                                                                  ]))
                                                                                : _createCommentVNode("", true),
                                                                              (p2.State==2 && (index2==0 || p.IsOpen==true))
                                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_216, [
                                                                                    _createTextVNode("删除了"),
                                                                                    _createElementVNode("span", _hoisted_217, _toDisplayString(p2.Label), 1),
                                                                                    _createTextVNode("，原值为\"" + _toDisplayString(p2.NewLabel) + "\"", 1)
                                                                                  ]))
                                                                                : _createCommentVNode("", true),
                                                                              (p2.State==999 && (index2==0 || p.IsOpen==true))
                                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_218, [
                                                                                    _createElementVNode("span", _hoisted_219, "未编辑" + _toDisplayString(p2.Label), 1),
                                                                                    _createTextVNode("，原值为\"" + _toDisplayString(p2.OldLabel) + "\"", 1)
                                                                                  ]))
                                                                                : _createCommentVNode("", true),
                                                                              (p.IsOpen==false && index2==0)
                                                                                ? (_openBlock(), _createElementBlock("div", {
                                                                                    key: 4,
                                                                                    onClick: ($event: any) => (p.IsOpen = !p.IsOpen),
                                                                                    style: {"margin-top":"5px","margin-left":"5px","cursor":"pointer","font-size":"10px","border":"1px solid #aaa","height":"16px","width":"16px","float":"left","text-align":"center","line-height":"16px"}
                                                                                  }, [
                                                                                    _createVNode(_component_el_icon, null, {
                                                                                      default: _withCtx(() => [
                                                                                        _createVNode(_component_Plus)
                                                                                      ]),
                                                                                      _: 1
                                                                                    })
                                                                                  ], 8, _hoisted_220))
                                                                                : _createCommentVNode("", true),
                                                                              (p.IsOpen==true && index2==0)
                                                                                ? (_openBlock(), _createElementBlock("div", {
                                                                                    key: 5,
                                                                                    onClick: ($event: any) => (p.IsOpen = !p.IsOpen),
                                                                                    style: {"margin-top":"5px","margin-left":"5px","cursor":"pointer","font-size":"10px","border":"1px solid #aaa","height":"16px","width":"16px","float":"left","text-align":"center","line-height":"16px"}
                                                                                  }, [
                                                                                    _createVNode(_component_el_icon, null, {
                                                                                      default: _withCtx(() => [
                                                                                        _createVNode(_component_Minus)
                                                                                      ]),
                                                                                      _: 1
                                                                                    })
                                                                                  ], 8, _hoisted_221))
                                                                                : _createCommentVNode("", true),
                                                                              _hoisted_222
                                                                            ]))
                                                                          : (_openBlock(), _createElementBlock("div", _hoisted_223, [
                                                                              (p2.Title!=null && p2.Title!=undefined && p2.Title!='')
                                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_224, _toDisplayString(p2.Title), 1))
                                                                                : (_openBlock(), _createElementBlock("div", _hoisted_225, _toDisplayString(p2.NewLabel), 1))
                                                                            ])),
                                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p2.Child, (p3, index3) => {
                                                                          return (_openBlock(), _createElementBlock("div", {
                                                                            key: index3,
                                                                            style: {"line-height":"28px"}
                                                                          }, [
                                                                            (p3.State==4 && (index3==0 || p2.IsOpen==true))
                                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_226, [
                                                                                  _createTextVNode("新增了"),
                                                                                  _createElementVNode("span", _hoisted_227, _toDisplayString(p3.Label), 1),
                                                                                  _createTextVNode("，新值为\"" + _toDisplayString(p3.NewLabel) + "\"", 1)
                                                                                ]))
                                                                              : _createCommentVNode("", true),
                                                                            (p3.State==3 && (index3==0 || p2.IsOpen==true))
                                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_228, [
                                                                                  _createTextVNode("编辑了"),
                                                                                  _createElementVNode("span", _hoisted_229, _toDisplayString(p3.Label), 1),
                                                                                  _createTextVNode("，由\"" + _toDisplayString(p3.OldLabel) + "\"改为\"" + _toDisplayString(p3.NewLabel) + "\"", 1)
                                                                                ]))
                                                                              : _createCommentVNode("", true),
                                                                            (p3.State==2 && (index3==0 || p2.IsOpen==true))
                                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_230, [
                                                                                  _createTextVNode("删除了"),
                                                                                  _createElementVNode("span", _hoisted_231, _toDisplayString(p3.Label), 1),
                                                                                  _createTextVNode("，原值为\"" + _toDisplayString(p3.NewLabel) + "\"", 1)
                                                                                ]))
                                                                              : _createCommentVNode("", true),
                                                                            (p3.State==999 && (index3==0 || p2.IsOpen==true))
                                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_232, [
                                                                                  _createElementVNode("span", _hoisted_233, "未编辑" + _toDisplayString(p3.Label), 1),
                                                                                  _createTextVNode("，原值为\"" + _toDisplayString(p3.OldLabel) + "\"", 1)
                                                                                ]))
                                                                              : _createCommentVNode("", true),
                                                                            (p2.IsOpen==false && index3==0)
                                                                              ? (_openBlock(), _createElementBlock("div", {
                                                                                  key: 4,
                                                                                  onClick: ($event: any) => (p2.IsOpen = !p2.IsOpen),
                                                                                  style: {"margin-top":"5px","margin-left":"5px","cursor":"pointer","font-size":"10px","border":"1px solid #aaa","height":"16px","width":"16px","float":"left","text-align":"center","line-height":"16px"}
                                                                                }, [
                                                                                  _createVNode(_component_el_icon, null, {
                                                                                    default: _withCtx(() => [
                                                                                      _createVNode(_component_Plus)
                                                                                    ]),
                                                                                    _: 1
                                                                                  })
                                                                                ], 8, _hoisted_234))
                                                                              : _createCommentVNode("", true),
                                                                            (p2.IsOpen==true && index3==0)
                                                                              ? (_openBlock(), _createElementBlock("div", {
                                                                                  key: 5,
                                                                                  onClick: ($event: any) => (p2.IsOpen = !p2.IsOpen),
                                                                                  style: {"margin-top":"5px","margin-left":"5px","cursor":"pointer","font-size":"10px","border":"1px solid #aaa","height":"16px","width":"16px","float":"left","text-align":"center","line-height":"16px"}
                                                                                }, [
                                                                                  _createVNode(_component_el_icon, null, {
                                                                                    default: _withCtx(() => [
                                                                                      _createVNode(_component_Minus)
                                                                                    ]),
                                                                                    _: 1
                                                                                  })
                                                                                ], 8, _hoisted_235))
                                                                              : _createCommentVNode("", true),
                                                                            _hoisted_236
                                                                          ]))
                                                                        }), 128))
                                                                      ]))
                                                                    }), 128))
                                                                  ]))
                                                                : (_openBlock(), _createElementBlock("div", _hoisted_237, "—"))
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        _hoisted_238
                                                      ]))
                                                    : (_openBlock(), _createElementBlock("div", _hoisted_239, [
                                                        (p.Child==null || p.Child==undefined || p.Child.length<=0)
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_240, [
                                                              (p.State==4)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_241, [
                                                                    _createTextVNode("新增了"),
                                                                    _createElementVNode("span", _hoisted_242, _toDisplayString(p.Label), 1),
                                                                    _createTextVNode("，新值为\"" + _toDisplayString(p.NewLabel) + "\"", 1)
                                                                  ]))
                                                                : _createCommentVNode("", true),
                                                              (p.State==3)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_243, [
                                                                    _createTextVNode("编辑了"),
                                                                    _createElementVNode("span", _hoisted_244, _toDisplayString(p.Label), 1),
                                                                    _createTextVNode("，由\"" + _toDisplayString(p.OldLabel) + "\"改为\"" + _toDisplayString(p.NewLabel) + "\"", 1)
                                                                  ]))
                                                                : _createCommentVNode("", true),
                                                              (p.State==2)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_245, [
                                                                    _createTextVNode("删除了"),
                                                                    _createElementVNode("span", _hoisted_246, _toDisplayString(p.Label), 1),
                                                                    _createTextVNode("，原值为\"" + _toDisplayString(p.NewLabel) + "\"", 1)
                                                                  ]))
                                                                : _createCommentVNode("", true),
                                                              (p.State==999)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_247, [
                                                                    _createElementVNode("span", _hoisted_248, "未编辑" + _toDisplayString(p.Label), 1),
                                                                    _createTextVNode("，原值为\"" + _toDisplayString(p.OldLabel) + "\"", 1)
                                                                  ]))
                                                                : _createCommentVNode("", true)
                                                            ]))
                                                          : (_openBlock(), _createElementBlock("div", _hoisted_249, [
                                                              (p.Title!=null && p.Title!=undefined && p.Title!='')
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_250, _toDisplayString(p.Title), 1))
                                                                : (_openBlock(), _createElementBlock("div", _hoisted_251, _toDisplayString(p.NewLabel), 1)),
                                                              _createElementVNode("div", _hoisted_252, [
                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p.Child, (p3, index3) => {
                                                                  return (_openBlock(), _createElementBlock("div", {
                                                                    style: {"clear":"both"},
                                                                    key: index3
                                                                  }, [
                                                                    (p3.State==4)
                                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_253, [
                                                                          _createTextVNode("新增了"),
                                                                          _createElementVNode("span", _hoisted_254, _toDisplayString(p3.Label), 1),
                                                                          _createTextVNode("，新值为\"" + _toDisplayString(p3.NewLabel) + "\"", 1)
                                                                        ]))
                                                                      : _createCommentVNode("", true),
                                                                    (p3.State==3)
                                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_255, [
                                                                          _createTextVNode("编辑了"),
                                                                          _createElementVNode("span", _hoisted_256, _toDisplayString(p3.Label), 1),
                                                                          _createTextVNode("，由\"" + _toDisplayString(p3.OldLabel) + "\"改为\"" + _toDisplayString(p3.NewLabel) + "\"", 1)
                                                                        ]))
                                                                      : _createCommentVNode("", true),
                                                                    (p3.State==2)
                                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_257, [
                                                                          _createTextVNode("删除了"),
                                                                          _createElementVNode("span", _hoisted_258, _toDisplayString(p3.Label), 1),
                                                                          _createTextVNode("，原值为\"" + _toDisplayString(p3.NewLabel) + "\"", 1)
                                                                        ]))
                                                                      : _createCommentVNode("", true),
                                                                    (p3.State==999)
                                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_259, [
                                                                          _createElementVNode("span", _hoisted_260, "未编辑" + _toDisplayString(p3.Label), 1),
                                                                          _createTextVNode("，原值为\"" + _toDisplayString(p3.OldLabel) + "\"", 1)
                                                                        ]))
                                                                      : _createCommentVNode("", true)
                                                                  ]))
                                                                }), 128)),
                                                                _hoisted_261
                                                              ]),
                                                              _hoisted_262
                                                            ]))
                                                      ]))
                                                ]))
                                              }), 128))
                                            ]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _: 2
                                  }, 1032, ["timestamp"]))
                                }), 128))
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createElementBlock("div", _hoisted_263, " 暂无数据 "))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _hoisted_264,
            _createElementVNode("div", _hoisted_265, [
              _createVNode(_component_miezz_button_bar, {
                modelValue: _ctx.settlementBottomButtons,
                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.settlementBottomButtons) = $event)),
                isBackground: true,
                onHandleClick: _ctx.handleClickSettlement
              }, null, 8, ["modelValue", "onHandleClick"])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.grossProfitDetailForm.Visible,
      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.grossProfitDetailForm.Visible) = $event)),
      "show-close": false,
      style: {"width":"80%"},
      top: "0px",
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "append-to-body": true
    }, {
      header: _withCtx(({ close }) => [
        _hoisted_266,
        _createElementVNode("div", _hoisted_267, [
          _createVNode(_component_el_icon, {
            style: {"cursor":"pointer"},
            onClick: close
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CloseBold)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_268, [
          _createElementVNode("div", _hoisted_269, [
            _hoisted_270,
            (_ctx.result.GrossProfit.GrossProfitDetail!=null && _ctx.result.GrossProfit.GrossProfitDetail.CollectionDetail!='')
              ? (_openBlock(), _createElementBlock("span", _hoisted_271, _toDisplayString(_ctx.result.GrossProfit.GrossProfitDetail.CollectionDetail), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_272, "CNY 0"))
          ]),
          _createElementVNode("div", _hoisted_273, [
            _hoisted_274,
            (_ctx.result.GrossProfit.GrossProfitDetail!=null && _ctx.result.GrossProfit.GrossProfitDetail.PaymentDetail!='')
              ? (_openBlock(), _createElementBlock("span", _hoisted_275, _toDisplayString(_ctx.result.GrossProfit.GrossProfitDetail.PaymentDetail), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_276, "CNY 0")),
            (_ctx.result.GrossProfit.GrossProfitDetail.IsShare == false)
              ? (_openBlock(), _createElementBlock("span", _hoisted_277, [
                  _createTextVNode(" 存在未分摊应付费用 "),
                  _createElementVNode("span", {
                    style: {"margin-left":"10px","cursor":"pointer","color":"#fe995b"},
                    onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.onShare()))
                  }, " 查看账单 ")
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_278, [
            _hoisted_279,
            (_ctx.result.GrossProfit.GrossProfitDetail!=null && _ctx.result.GrossProfit.GrossProfitDetail.GrossProfitDetail!='')
              ? (_openBlock(), _createElementBlock("span", _hoisted_280, _toDisplayString(_ctx.result.GrossProfit.GrossProfitDetail.GrossProfitDetail), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_281, "CNY 0"))
          ]),
          _createElementVNode("div", _hoisted_282, [
            _hoisted_283,
            _createElementVNode("span", null, _toDisplayString(_ctx.isString(_ctx.result.GrossProfit.GrossProfitDetail.GrossPointDetail)), 1)
          ])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_el_table, {
            stripe: "",
            border: "",
            "tree-props": {children: 'Child', hasChildren: 'hasChildren'},
            "row-key": "Id",
            "default-expand-all": false,
            data: _ctx.result.GrossProfit.GrossProfitDetail.Pools,
            ref: "$grossProfitDetailTable",
            style: {"width":"100%","margin-top":"15px"},
            "header-cell-style": { 'text-align': 'left' },
            "cell-style": { 'text-align': 'left' }
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "scope.row.BookingNo",
                label: "BookingNo",
                "show-overflow-tooltip": true,
                width: "150"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_284, _toDisplayString(_ctx.isString(scope.row.BookingNo)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "scope.row.CustomerServiceLabel",
                label: "客服",
                "show-overflow-tooltip": true,
                width: "150"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_285, _toDisplayString(_ctx.isString(scope.row.CustomerServiceLabel)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "scope.row.SalerName",
                label: "业务员",
                "show-overflow-tooltip": true,
                width: "150"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_286, _toDisplayString(_ctx.isString(scope.row.SalerName)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "scope.row.Collection",
                label: "应收合计",
                "show-overflow-tooltip": true
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_287, _toDisplayString(_ctx.isString(scope.row.Collection)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "scope.row.Collection",
                label: "应收坏账",
                "show-overflow-tooltip": true
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_288, _toDisplayString(_ctx.isString(scope.row.BadCollectionSettlement)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "scope.row.Payment",
                label: "应付合计",
                "show-overflow-tooltip": true
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_289, _toDisplayString(_ctx.isString(scope.row.Payment)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "scope.row.Payment",
                label: "应付坏账",
                "show-overflow-tooltip": true
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_290, _toDisplayString(_ctx.isString(scope.row.BadPaymentSettlement)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "scope.row.Profit",
                label: "毛利润合计",
                "show-overflow-tooltip": true
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    style: _normalizeStyle([scope.row.IsProfit==true?'color:red;':'', {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}])
                  }, _toDisplayString(_ctx.isString(scope.row.Profit)), 5)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "scope.row.GrossPointString",
                label: "单票毛利率",
                "show-overflow-tooltip": true,
                width: "100"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_291, _toDisplayString(_ctx.isString(scope.row.GrossPointString)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "scope.row.Collection",
                label: "操作",
                "show-overflow-tooltip": true,
                width: "100"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    onClick: ($event: any) => (_ctx.onPool(scope.row)),
                    style: {"cursor":"pointer","color":"#fe995b","width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
                  }, " 查看账单 ", 8, _hoisted_292)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])
        ]),
        _hoisted_293,
        _createVNode(_component_miezz_button_bar, {
          modelValue: _ctx.grossProfitDetailBottomButtons,
          "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.grossProfitDetailBottomButtons) = $event)),
          isBackground: true,
          onHandleClick: _ctx.handleClickGrossProfitDetail
        }, null, 8, ["modelValue", "onHandleClick"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.settlementVisible,
      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.settlementVisible) = $event)),
      "show-close": false,
      style: {"width":"80%"},
      top: "0px",
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "append-to-body": true
    }, {
      header: _withCtx(({ close }) => [
        _hoisted_294,
        _createElementVNode("div", _hoisted_295, [
          _createVNode(_component_el_icon, {
            style: {"cursor":"pointer"},
            onClick: close
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CloseBold)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_el_table, {
            stripe: "",
            border: "",
            "tree-props": {children: 'Child', hasChildren: 'hasChildren'},
            "row-key": "Id",
            "default-expand-all": false,
            data: _ctx.result.Settlements,
            ref: "$settlementTable",
            style: {"width":"100%","margin-top":"15px"},
            "header-cell-style": { 'text-align': 'left' },
            "cell-style": { 'text-align': 'left' }
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "scope.row.BookingNo",
                label: "BookingNo",
                "show-overflow-tooltip": true,
                width: "150"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_296, _toDisplayString(_ctx.isString(scope.row.BookingNo)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "scope.row.OrderCode",
                label: "订单编号",
                "show-overflow-tooltip": true,
                width: "150"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_297, _toDisplayString(_ctx.isString(scope.row.OrderCode)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "scope.row.Price",
                label: "核销金额",
                "show-overflow-tooltip": true
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_298, _toDisplayString(_ctx.isString(scope.row.CurrencySystemCode)) + _toDisplayString(_ctx.isString(_ctx.formatNumber(scope.row.Price))), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "scope.row.Rate",
                label: "汇率",
                "show-overflow-tooltip": true,
                width: "100"
              }, {
                default: _withCtx((scope) => [
                  (scope.row.Mode != '坏账核销')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_299, _toDisplayString(_ctx.isString(scope.row.Rate)), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_300, " — "))
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "scope.row.SettlementDate",
                label: "核销时间",
                "show-overflow-tooltip": true,
                width: "150"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_301, _toDisplayString(_ctx.isString(scope.row.SettlementDate)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "scope.row.CollectionTitle",
                label: "收款方",
                "show-overflow-tooltip": true
              }, {
                default: _withCtx((scope) => [
                  (scope.row.Mode != '坏账核销')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_302, _toDisplayString(_ctx.isString(scope.row.CollectionTitle)), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_303, " — "))
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "scope.row.PaymentTitle",
                label: "付款方",
                "show-overflow-tooltip": true
              }, {
                default: _withCtx((scope) => [
                  (scope.row.Mode != '坏账核销')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_304, _toDisplayString(_ctx.isString(scope.row.PaymentTitle)), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_305, " — "))
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "scope.row.Mode",
                label: "核销方式",
                "show-overflow-tooltip": true,
                width: "100"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_306, _toDisplayString(_ctx.isString(scope.row.Mode)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "scope.row.Remark",
                label: "备注",
                "show-overflow-tooltip": true
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_307, _toDisplayString(_ctx.isString(scope.row.Remark)), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])
        ]),
        _hoisted_308,
        _createVNode(_component_miezz_button_bar, {
          modelValue: _ctx.settlementDetailBottomButtons,
          "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.settlementDetailBottomButtons) = $event)),
          isBackground: true,
          onHandleClick: _ctx.handleClickSettlementDetail
        }, null, 8, ["modelValue", "onHandleClick"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ])), [
    [
      _directive_loading,
      _ctx.isLoading,
      void 0,
      {
        fullscreen: true,
        lock: true
      }
    ]
  ])
}